import { Dialog, DialogModule, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject, Injector, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { pathParameter, queryParameter } from '@libs/shared-services';
import { toSignal } from '@angular/core/rxjs-interop';
import { routes } from '@libs/utils';
import { NotesScreenService } from '@libs/notes';
import { ToothDetailsDialogComponent } from 'libs/charting/src/lib/components/tooth-details-dialog/tooth-details-dialog.component';
import { ToothDetailsDialogData } from 'libs/charting/src/lib/components/tooth-details-dialog/tooth-details-dialog.vm';

@Component({
  selector: 'ffd-perio-tooth-details-dialog-container',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, DialogModule],
})
export class PerioToothDetailsDialogContainerComponent implements OnInit, OnDestroy {
  private readonly dialog = inject(Dialog);
  private readonly injector = inject(Injector);
  private dialogRef: DialogRef<ToothDetailsDialogComponent> | null = null;

  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly params = toSignal(this.activatedRoute.paramMap);
  private readonly queryParams = toSignal(this.activatedRoute.queryParamMap);
  private readonly router = inject(Router);
  private readonly notesService = inject(NotesScreenService);

  public ngOnInit(): void {
    const siteId = this.params()!.get(pathParameter('siteId')) ?? undefined;
    const patientId = this.params()!.get(pathParameter('patientId')) ?? undefined;
    const toothPosition = Number(this.params()!.get(pathParameter('toothPosition')));
    const date = Number(this.queryParams()!.get(queryParameter('date'))) ?? undefined;

    this.notesService.init();
    if (!siteId || !patientId || Number.isNaN(toothPosition)) {
      this.router.navigate([routes.perio, siteId, routes.patients, patientId]);
    }
    this.dialogRef = this.dialog.open<ToothDetailsDialogComponent, ToothDetailsDialogData>(ToothDetailsDialogComponent, {
      backdropClass: ['backdrop-blur-overlay', 'bg-overlay-light', 'tooth-details-modal-backdrop'],
      disableClose: true,
      data: {
        screen: 'perio',
        toothPosition,
        siteId,
        patientId,
        date,
      },
      autoFocus: '__non_existing_element__',
      injector: this.injector,
    });
  }

  public ngOnDestroy(): void {
    this.dialogRef?.close();
  }
}
